import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

// DB-Override eines als `.md` ausgelieferten System-Prompts (PV-003).
// `key` entspricht dem Dateinamen ohne `.md` (z. B. `mission-briefing`).
export const PromptOverrideSchema = z.object({
  prompt_id: UuidSchema,
  key: z.string().min(1),
  content: z.string().min(1),
  is_active: z.boolean(),
  updated_at: IsoDateTimeSchema,
  updated_by: UuidSchema.nullable(),
});
export type PromptOverride = z.infer<typeof PromptOverrideSchema>;

// GET-Response je bekanntem Prompt-Key: aktiver Inhalt + Default zum Vergleich.
export const PromptListItemSchema = z.object({
  key: z.string().min(1),
  // Aktiver Inhalt: Override-content wenn vorhanden, sonst der `.md`-Default.
  content: z.string().min(1),
  // Der ausgelieferte `.md`-Default (immer, unabhängig vom Override).
  default_content: z.string().min(1),
  is_overridden: z.boolean(),
  updated_at: IsoDateTimeSchema.nullable(),
  updated_by: UuidSchema.nullable(),
});
export type PromptListItem = z.infer<typeof PromptListItemSchema>;

// PUT-Body: leerer Prompt ist nicht speicherbar.
export const UpdatePromptInputSchema = z.object({
  content: z.string().min(1),
});
export type UpdatePromptInput = z.infer<typeof UpdatePromptInputSchema>;
